import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import { FormBuilder } from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { ToolsService } from 'src/app/utils/tools.service';
import SwalAlert from 'src/app/utils/swalalert';
import { WarehouseService } from 'src/app/api/config/warehouse.service';
import { GroupService } from 'src/app/api/departure/group.service';
import { BookingsExtendsComponent } from 'src/app/booking/bookings/bookings-extends/bookings-extends.component';
import { constants } from 'src/app/constants';
declare var $: any;

@Component({
  selector: 'app-group-detail',
  templateUrl: './group-detail.component.html',
  styleUrls: ['./group-detail.component.css']
})
export class GroupDetailComponent implements OnInit {
  @ViewChild(BookingsExtendsComponent) BookingsExtendsComponent: any;

  branchofficeSlug: string = '';
  checkId: number;

  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // arrays
  book: any = null;
  bookings: any = [];
  vehicle_private: any = constants.TOURISM.VEHICLE_TOURS[1].id;

  // for audit info
  audits_results: any = [];
  selectedAudit: any = null;
  expandedIndex: number | null = null;
  filteredAuditsBooking: any[] = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private routeActivated: ActivatedRoute,
    private globalService: GlobalService,
    private groupService: GroupService,
    private navigationTrackerService: NavigationTrackerService,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private alert: SwalAlert
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.routeActivated.snapshot.params['id'];
    this.editData();
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    (<any>$('[data-toggle="tooltip"]')).tooltip();
  }

  editData(check_id = null) {
    this.groupService.detail(this.checkId).subscribe({
      next: (data: any) => {
        let result = data.data;
        this.book = result.book;
        this.bookings = result.bookings;        
      }
    });
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/salidas/grupos/editar',
      id
    ]);
  }

  delete(item: any) {
    let options = {
      title: '¿Estás segur@?',
      message: ' de grupo N° ' + item.code,
      cancel: 'Cancelar',
      confirm: 'Eliminar'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        this.groupService.delete(item.id).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success(
              'El registro de grupo ' + item.code + ' se ha eliminado con éxito'
            );
            this.cancel();
          }
        });
      }
    });
  }

  confirm() {
    let options = {
      title: '¿Estás segur@?',
      message:
        '¿Esta seguro(a) de confirmar la salida del grupo?, \n Una vez confirmada la salida, no se podrán realizar modificaciones',
      cancel: 'Cancelar',
      confirm: 'CONFIRMAR SALIDA'
    };
    let data: any = {};
    data.book = this.book;
    data.tours = this.bookings;
    this.alert.confirmInfo(options).then((result: any) => {
      if (result.isConfirmed) {
        this.groupService.confirmDeparture(this.book.id, data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('SALIDA DE GRUPO CONFIRMADA con éxito !');
            this.editData(this.book.id);
          }
        });
      }
    });
  }

  resetStatus() {
    let options = {
      title: '¿Estás segur@?',
      message:
        "¿Esta seguro(a) de resetear al estado anterior 'PENDIENTE' el grupo?",
      cancel: 'Cancelar',
      confirm: 'Sí, RESETEAR ESTADO'
    };
    let data: any = {};
    data.book = this.book;
    data.tours = this.bookings;
    this.alert.confirmInfo(options).then((result: any) => {
      if (result.isConfirmed) {
        this.groupService.resetStatusDeparture(this.book.id, data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Cambio de estado realizado con éxito !');
            this.editData(this.book.id);
          }
        });
      }
    });
  }

  detailBookingExtends(booking: any) {
    this.BookingsExtendsComponent.init(booking.booking_id);
  }

  afterBookingDetail(data: any) {
    this.editData();
  }

  printer() {
    (<any>$('#body')).printThis({
      importCSS: true
    });
  }

  getAuditing() {
    this.groupService.auditing(this.checkId).subscribe({
      next: (data: any) => {
        this.audits_results = data.audits_results;
        this.filteredAuditsBooking = this.audits_results.filter(
          (audit: { old_values: any; new_values: any }) =>
            !(this.isEmpty(audit.old_values) && this.isEmpty(audit.new_values))
        );
        (<any>$('#myModal')).modal('show');
      }
    });
  }

  isEmpty(obj: any): boolean {
    return obj && Object.keys(obj).length === 0;
  }

  objectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  toggleDetails(index: number, audit: any): void {
    if (this.expandedIndex === index) {
      this.expandedIndex = null;
      this.selectedAudit = null;
    } else {
      this.expandedIndex = index;
      this.selectedAudit = audit;
    }
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/salidas/grupos/lista']);
  }
}
